import React, { useState } from 'react'
import FlexLayout from 'src/components/FlexLayout'
import CustomField from './CustomField'
import Text from 'src/components/Text'
import { ArrowRight } from 'react-feather'
import { Formik, Form, Field } from 'formik'
import { addLeadingZeros } from 'src/services/Helper'
import { validateLocalization } from 'src/services/stock/stockService'

function WithdrawAddressComponent({
  productSelected,
  handleShow,
  setAddressSelected,
  listAddressesGondola = [],
  fcSelected,
  disableButtons
}) {
  const streetfieldsStyle = {
    width: '50px',
    marginRight: '5px'
  }

  const containerAddressesStyle = {
    borderRadius: '5px',
    boxShadow: '0px 0px 10px 1px rgba(0,0,0,0.44)',
    margin: '0 15px',
    width: '50%',
    height: 'auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...(!productSelected && { opacity: 0.5 })
  }

  const containerItemAddressStyle = {
    padding: '15px',
    height: 'auto'
  }

  const itemAddresseStyle = {
    height: 'auto',
    borderBottom: 'solid 1px #0000001f',
    borderLeft: 'solid 5px #143fef',
    borderRadius: '5px',
    padding: '15px'
  }

  const headerContainerStyle = { color: '#575757' }

  const buttonContinueExitStyle = {
    borderRadius: '50px',
    height: '35px',
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

  const [addressError, setAddressError] = useState('')
  const [resetForm, setResetForm] = useState(undefined)

  const handleSubmitChangeAddress = (values) => {
    setAddressSelected({
      addressId: values.id_localizacao,
      warehouse: values.piso,
      street: values.rua,
      shelf: values.estante,
      bin: values.escaninho
    })
    handleShow(
      values['id_localizacao'],
      productSelected.id_modelo,
      productSelected.id_lote,
      resetForm
    )
  }

  const validateAddress = async ({ shed, street, shelf, bin }) => {
    if (!shed || !street || !shelf || !bin) {
      setAddressError('Preencha todos os campos do endereço')
      return
    }

    const response = await validateLocalization(
      shed,
      street,
      shelf,
      bin,
      fcSelected.id
    )
    if (!response.isOk) {
      return
    }

    if (!response.data['endereço validado'].id_localizacao) {
      setAddressError(response.data['endereço validado'].message)
      return
    }

    setAddressError('')
    let id_location = response.data['endereço validado'].id_localizacao
    let values = {
      id_localizacao: id_location,
      piso: shed,
      rua: street,
      estante: shelf,
      escaninho: bin
    }

    handleSubmitChangeAddress(values)
  }

  const upperCaseOnChange = (e) => {
    let value = e.target.value

    if (typeof value == 'string') {
      return value.toUpperCase()
    }

    return value
  }

  return (
    <FlexLayout direction="column" style={containerAddressesStyle}>
      <Formik
        initialValues={{
          id_location: '',
          shed: '',
          street: '',
          shelf: '',
          bin: ''
        }}
      >
        {({ resetForm }) => (
          <Form>
            {productSelected && (
              <>
                {listAddressesGondola.length > 0 && (
                  <FlexLayout
                    direction="column"
                    style={containerItemAddressStyle}
                  >
                    {listAddressesGondola.filter(
                      (address) => address.tipo === 'GONDOLA'
                    ).length > 0 && (
                      <>
                        <h6 style={headerContainerStyle}>Saída para Gondola</h6>
                        <FlexLayout style={{ margin: '0 0 0 20px' }}>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.shed"
                              style={{ margin: '0 5px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.street"
                              style={{ margin: '0 25px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.shelf"
                              style={{ margin: '0 5px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.bin"
                              style={{ margin: '0 10px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.has-qty"
                            />
                          </div>
                        </FlexLayout>
                        {listAddressesGondola
                          .filter((address) => address.tipo === 'GONDOLA')
                          .map((addressGondola) => {
                            return (
                              <React.Fragment
                                key={{ addressGondola, tipo: 'GONDOLA' }}
                              >
                                <FlexLayout
                                  justify="between"
                                  style={itemAddresseStyle}
                                  align="center"
                                >
                                  <FlexLayout direction="column">
                                    <FlexLayout>
                                      <div>
                                        <CustomField
                                          name="shed"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.piso}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="street"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.rua}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="shelf"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.estante}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="bin"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.escaninho}
                                        />
                                      </div>
                                      <div>
                                        <Field
                                          style={{ marginLeft: '55px' }}
                                          type="checkbox"
                                          checked={
                                            addressGondola.qty ? true : false
                                          }
                                        />
                                      </div>
                                    </FlexLayout>
                                  </FlexLayout>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    style={buttonContinueExitStyle}
                                    disabled={disableButtons}
                                    onClick={() => {
                                      handleSubmitChangeAddress(addressGondola)
                                      setResetForm(() => resetForm)
                                    }}
                                  >
                                    <ArrowRight
                                      color="white"
                                      size={14}
                                      style={{ position: 'static' }}
                                    />
                                  </button>
                                </FlexLayout>
                              </React.Fragment>
                            )
                          })}
                      </>
                    )}
                    {listAddressesGondola.filter(
                      (address) => address.tipo === 'SURPLUS'
                    ).length > 0 && (
                      <>
                        <h6
                          style={{ ...headerContainerStyle, marginTop: '10px' }}
                        >
                          Saída para Excedente
                        </h6>
                        <FlexLayout style={{ margin: '0 0 0 20px' }}>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.shed"
                              style={{ margin: '0 5px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.street"
                              style={{ margin: '0 25px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.shelf"
                              style={{ margin: '0 5px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.bin"
                              style={{ margin: '0 10px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.has-qty"
                            />
                          </div>
                        </FlexLayout>
                        {listAddressesGondola
                          .filter((address) => address.tipo === 'SURPLUS')
                          .map((addressGondola) => {
                            return (
                              <React.Fragment
                                key={{ addressGondola, tipo: 'SURPLUS' }}
                              >
                                <FlexLayout
                                  justify="between"
                                  style={itemAddresseStyle}
                                  align="center"
                                >
                                  <FlexLayout direction="column">
                                    <FlexLayout>
                                      <div>
                                        <CustomField
                                          name="shed"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.piso}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="street"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.rua}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="shelf"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.estante}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="bin"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.escaninho}
                                        />
                                      </div>
                                      <div>
                                        <Field
                                          style={{ marginLeft: '55px' }}
                                          type="checkbox"
                                          checked={
                                            addressGondola.qty ? true : false
                                          }
                                        />
                                      </div>
                                    </FlexLayout>
                                  </FlexLayout>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    style={buttonContinueExitStyle}
                                    onClick={() => {
                                      handleSubmitChangeAddress(addressGondola)
                                      setResetForm(() => resetForm)
                                    }}
                                  >
                                    <ArrowRight
                                      color="white"
                                      size={14}
                                      style={{ position: 'static' }}
                                    />
                                  </button>
                                </FlexLayout>
                              </React.Fragment>
                            )
                          })}
                      </>
                    )}
                    {listAddressesGondola.filter(
                      (address) => address.tipo === 'EMPTY_TOP'
                    ).length > 0 && (
                      <>
                        <h6
                          style={{ ...headerContainerStyle, marginTop: '10px' }}
                        >
                          Endereços superiores vazios
                        </h6>
                        <FlexLayout style={{ margin: '0 0 0 20px' }}>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.shed"
                              style={{ margin: '0 5px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.street"
                              style={{ margin: '0 25px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.shelf"
                              style={{ margin: '0 5px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.address.bin"
                              style={{ margin: '0 10px 0 0' }}
                            />
                          </div>
                          <div>
                            <Text
                              textType="default"
                              text="receivement.form.has-qty"
                            />
                          </div>
                        </FlexLayout>
                        {listAddressesGondola
                          .filter((address) => address.tipo === 'EMPTY_TOP')
                          .map((addressGondola) => {
                            return (
                              <React.Fragment
                                key={{ addressGondola, tipo: 'EMPTY_TOP' }}
                              >
                                <FlexLayout
                                  justify="between"
                                  style={itemAddresseStyle}
                                  align="center"
                                >
                                  <FlexLayout direction="column">
                                    <FlexLayout>
                                      <div>
                                        <CustomField
                                          name="shed"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.piso}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="street"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.rua}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="shelf"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.estante}
                                        />
                                      </div>
                                      <div>
                                        <CustomField
                                          name="bin"
                                          isDisabled
                                          style={streetfieldsStyle}
                                          value={addressGondola.escaninho}
                                        />
                                      </div>
                                      <div>
                                        <Field
                                          style={{ marginLeft: '55px' }}
                                          type="checkbox"
                                          checked={
                                            addressGondola.qty ? true : false
                                          }
                                        />
                                      </div>
                                    </FlexLayout>
                                  </FlexLayout>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    style={buttonContinueExitStyle}
                                    onClick={() => {
                                      handleSubmitChangeAddress(addressGondola)
                                    }}
                                  >
                                    <ArrowRight
                                      color="white"
                                      size={14}
                                      style={{ position: 'static' }}
                                    />
                                  </button>
                                </FlexLayout>
                              </React.Fragment>
                            )
                          })}
                      </>
                    )}
                  </FlexLayout>
                )}
              </>
            )}
          </Form>
        )}
      </Formik>
      <Formik
        initialValues={{
          id_location: '',
          customShed: '',
          customStreet: '',
          customShelf: '',
          customBin: ''
        }}
        onSubmit={(
          { customShed, customStreet, customShelf, customBin },
          { resetForm }
        ) => {
          const formatedValues = {
            shed: customShed,
            street: customStreet,
            shelf: customShelf,
            bin: customBin
          }
          setResetForm(() => resetForm)
          validateAddress(formatedValues)
        }}
      >
        {({ setFieldValue }) => (
          <Form>
            <FlexLayout direction="column" style={containerItemAddressStyle}>
              <h6 style={headerContainerStyle}>Saída Outro Endereço</h6>
              {listAddressesGondola.length == 0 && (
                <FlexLayout style={{ margin: '0 0 0 20px' }}>
                  <div>
                    <Text
                      textType="default"
                      text="receivement.form.address.shed"
                      style={{ margin: '0 5px 0 0' }}
                    />
                  </div>
                  <div>
                    <Text
                      textType="default"
                      text="receivement.form.address.street"
                      style={{ margin: '0 25px 0 0' }}
                    />
                  </div>
                  <div>
                    <Text
                      textType="default"
                      text="receivement.form.address.shelf"
                      style={{ margin: '0 5px 0 0' }}
                    />
                  </div>
                  <div>
                    <Text
                      textType="default"
                      text="receivement.form.address.bin"
                      style={{ margin: '0 10px 0 0' }}
                    />
                  </div>
                </FlexLayout>
              )}
              <FlexLayout
                justify="between"
                style={itemAddresseStyle}
                align="center"
              >
                <FlexLayout direction="column">
                  <FlexLayout>
                    <div>
                      <CustomField
                        name="customShed"
                        style={streetfieldsStyle}
                        onChange={(e) =>
                          setFieldValue('customShed', upperCaseOnChange(e))
                        }
                      />
                    </div>
                    <div>
                      <CustomField
                        name="customStreet"
                        style={streetfieldsStyle}
                        onChange={(e) =>
                          setFieldValue('customStreet', upperCaseOnChange(e))
                        }
                      />
                    </div>
                    <div>
                      <CustomField
                        name="customShelf"
                        style={streetfieldsStyle}
                        onChange={(e) =>
                          setFieldValue('customShelf', upperCaseOnChange(e))
                        }
                        onKeyUp={(e) => {
                          setFieldValue(
                            'customShelf',
                            addLeadingZeros(e.target.value, 3)
                          )
                        }}
                      />
                    </div>
                    <div>
                      <CustomField
                        name="customBin"
                        style={streetfieldsStyle}
                        onChange={(e) =>
                          setFieldValue('customBin', upperCaseOnChange(e))
                        }
                      />
                    </div>
                  </FlexLayout>
                  {addressError && (
                    <p style={{ color: 'red', marginTop: '10px' }}>
                      {' '}
                      {addressError}{' '}
                    </p>
                  )}
                </FlexLayout>

                <button
                  className="btn btn-primary submit-button"
                  type="submit"
                  style={buttonContinueExitStyle}
                  disabled={disableButtons}
                >
                  <ArrowRight
                    color="white"
                    size={14}
                    style={{ position: 'static' }}
                  />
                </button>
              </FlexLayout>
            </FlexLayout>
          </Form>
        )}
      </Formik>
    </FlexLayout>
  )
}

export default WithdrawAddressComponent
